import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { StyledSvg } from "./SvgIcon.styles";
import { iconDefinitions } from "./svgIconDefinitions";
var SvgIcon = function(_param) {
    var name = _param.name, _size = _param.size, size = _size === void 0 ? "small" : _size, props = _object_without_properties(_param, [
        "name",
        "size"
    ]);
    var iconDefinition = iconDefinitions[name];
    return /*#__PURE__*/ _jsx(StyledSvg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: iconDefinition === null || iconDefinition === void 0 ? void 0 : iconDefinition.viewBox,
        role: "img",
        size: size
    }, props), {
        children: iconDefinition === null || iconDefinition === void 0 ? void 0 : iconDefinition.svg
    }));
};
export { SvgIcon };
